import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';

import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaTag } from 'react-icons/fa';
import { FaHubspot } from 'react-icons/fa';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Loading,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
} from '~/components';

import {
  GraphArea,
  LoadArea,
  Tags,
  ToogleInfo,
  Align,
  Thumb,
  Legend,
} from './styles';

import Grafico from './Grafico';

import RelatorioVendaCanal from '~/@types/relatoriovendacanal';
import RelatorioVendaCanalMetrica from '~/@types/RelatorioVendaCanalMetrica';
import { ProgressTag } from '../Dashboard/styles';

const VendasPorCanal: React.FC = () => {
  const { colors } = useTheme();

  const [inLoad, setInLoad] = useState(false);

  const [vendascanal, setVendascanal] = useState<RelatorioVendaCanal[]>([]);
  const [vendasCanalVisibilidade, setGraficoVisibilidade] = useState(true);
  const [moduloGrafico, setModuloGrafico] = useState('hoje');

  // MODULO (VENDAS POR UF)
  const filtrarUfsPorModulo = (
    pModuloGrafico: string,
    pGraficos: RelatorioVendaCanal[],
  ) => {
    const canais: RelatorioVendaCanalMetrica[] = [];

    let c;
    for (c in pGraficos) {
      const relatorio = pGraficos[c];
      if (relatorio.nome === pModuloGrafico) {
        let d;
        for (d in relatorio.canais) {
          const canal = relatorio.canais[d];
          canais.push(canal);
        }
      }
    }

    return canais;
  };

  const gerarRelatorioGraficoCSV = () => {
    let data: string[] = [];

    data.push('CANAL;PEDIDOS;TICKETMEDIO;TOTAL');

    const canais = filtrarUfsPorModulo(moduloGrafico, vendascanal);

    let d;
    for (d in canais) {
      const canal = canais[d];

      data.push(
        `${canal.nome};${canal.pedidos};${canal.ticketmedio};${canal.total}`,
      );
    }

    const csv = data.join('\n');

    exportCsv(csv, `VENDAS POR CANAL - ${moduloGrafico.toUpperCase()}`);
  };

  const gerarRelatoriosGraficoPDF = () => {
    const cabecalho = ['CANAL', 'PEDIDOS', 'TICKETMEDIO', 'TOTAL'];

    const data: string[][] = [];

    const canais = filtrarUfsPorModulo(moduloGrafico, vendascanal);

    let d;
    for (d in canais) {
      const canal = canais[d];

      const linha: string[] = [];

      linha.push(`${canal.nome}`);
      linha.push(`${canal.pedidos}`);
      linha.push(`${canal.ticketmedio}`);
      linha.push(`${canal.total}`);

      data.push(linha);
    }

    exportPdf(
      cabecalho,
      data,
      `VENDAS POR CANAL - ${moduloGrafico.toUpperCase()}`,
    );
  };

  const exibicaoTotalPedidos = (pTotalPedidos: number) => {
    if (!pTotalPedidos) return 'Nenhum pedido';
    if (pTotalPedidos === 1) {
      return 'Um pedido';
    }
    return `${pTotalPedidos} pedidos`;
  };

  useEffect(() => {
    const fetchVendasPorCanal = async () => {
      try {
        setInLoad(true);
        setVendascanal([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_por_canal';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setVendascanal(data);
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };
    fetchVendasPorCanal();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Vendas por canal"
            subtitle="Confira as métricas de vendas distribuídas por canal"
            icon={
              <>
                <FaHubspot size={32} color={colors.IC1} />
              </>
            }
          />

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          {vendascanal.length ? (
            <GraphArea>
              <header>
                <i>
                  <FaHubspot size={26} color={colors.IC1} />
                </i>
                <p>
                  <h1>Vendas por canal</h1>
                  <h2>Confira as métricas de vendas distribuídas por canal</h2>
                </p>

                <div>
                  <button
                    className="excel"
                    onClick={gerarRelatorioGraficoCSV}
                    title="Exportar para Excel"
                  >
                    <FaFileExcel size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>EXCEL</h2>
                    </div>
                  </button>
                  <button
                    className="pdf"
                    onClick={gerarRelatoriosGraficoPDF}
                    title="Exportar para PDF"
                  >
                    <FaFilePdf size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>PDF</h2>
                    </div>
                  </button>
                </div>
              </header>

              <Tags>
                <div>
                  <button
                    className={moduloGrafico === 'hoje' ? 'active' : ''}
                    onClick={() => setModuloGrafico('hoje')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Hoje</span>
                  </button>
                  <button
                    className={
                      moduloGrafico === 'ultimos-7-dias' ? 'active' : ''
                    }
                    onClick={() => setModuloGrafico('ultimos-7-dias')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Últimos 7 Dias</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Passado</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Passado</span>
                  </button>
                </div>
              </Tags>

              <main>
                <div>
                  <Grafico
                    canais={filtrarUfsPorModulo(moduloGrafico, vendascanal)}
                  />
                </div>
              </main>

              <footer>
                {vendasCanalVisibilidade ? (
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="Canal" width={60} />
                      <GridHeadItem title="Pedidos" />
                      <GridHeadItem title="Total" width={160} />
                      <GridHeadItem title="Ticket Médio" width={160} />
                    </GridLine>

                    {filtrarUfsPorModulo(moduloGrafico, vendascanal).map(
                      canal => (
                        <GridLine key={canal.nome}>
                          <GridItem width={60}>
                            <Legend>
                              <Thumb>
                                <img
                                  src={`https://commerceplus.com.br/includes/bandeiras/${canal.nome}.jpg`}
                                  alt={canal.nome}
                                  title={canal.nome}
                                />
                              </Thumb>
                              <h1>{canal.nome}</h1>
                            </Legend>
                          </GridItem>
                          <GridItem>
                            <Align>
                              <div>{exibicaoTotalPedidos(canal.pedidos)}</div>
                              <ProgressTag>
                                {canal.pedidos_porcentagem}%
                              </ProgressTag>
                            </Align>
                          </GridItem>
                          <GridItem width={160}>
                            <Align>
                              <div>
                                {canal.total.toLocaleString('pt-br', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })}
                              </div>
                              <ProgressTag>
                                {canal.faturamento_porcentagem}%
                              </ProgressTag>
                            </Align>
                          </GridItem>
                          <GridItem width={160}>
                            <Align>
                              {canal.ticketmedio.toLocaleString('pt-br', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </Align>
                          </GridItem>
                        </GridLine>
                      ),
                    )}
                  </Grid>
                ) : null}
                <ToogleInfo
                  onClick={() =>
                    setGraficoVisibilidade(!vendasCanalVisibilidade)
                  }
                >
                  {vendasCanalVisibilidade ? (
                    <IoMdArrowDropup size={32} color={colors.IC1} />
                  ) : (
                    <IoMdArrowDropdown size={32} color={colors.IC1} />
                  )}
                </ToogleInfo>
              </footer>
            </GraphArea>
          ) : null}
        </Container>
      </Scroll>
    </>
  );
};

export default VendasPorCanal;
